// Bilingual (English / Hindi) content for Hari Om Bol landing page.

export const translations = {
  en: {
    brand: "Hari Om Bol",
    nav: {
      about: "About",
      features: "Features",
      pricing: "Pricing",
      faq: "FAQ",
      download: "Download",
      downloadApp: "Download App",
    },
    hero: {
      eyebrow: "One subscription · Endless guidance",
      headingLine1: "Your Spiritual Companion,",
      headingPre: "Whenever Life Needs ",
      headingEmph: "Answers.",
      subtitle:
        "Connect with verified Astrologers and compassionate Saathi through voice calls and chats—all with one affordable subscription.",
      subtitleStrong: "No per-minute charges. Just trusted guidance.",
      badges: [
        "No Per-Minute Charges",
        "Verified Experts",
        "Private & Secure",
        "Subscription Based",
      ],
    },
    marquee: [
      "Trusted Guidance",
      "Compassionate Saathi",
      "Private & Secure",
      "Verified Astrologers",
      "One Subscription",
      "No Per-Minute Charges",
    ],
    about: {
      label: "About Hari Om Bol",
      heading:
        "Genuine guidance, from people who truly understand your journey.",
      p1: "Looking for genuine spiritual guidance, trusted astrologers, or someone who truly understands your life\u2019s journey? Hari Om Bol connects you with experienced Astrologers and dedicated Saathi through voice calls and chats.",
      p2pre: "Unlike traditional astrology apps, Hari Om Bol does ",
      p2strong: "not charge per minute",
      p2rest:
        "\u2014allowing you to focus on finding answers instead of watching the clock.",
      topicsLabel: "Whether you seek guidance on:",
      topics: [
        "Career",
        "Marriage",
        "Relationships",
        "Finance",
        "Business",
        "Health",
        "Family",
        "Spiritual Growth",
      ],
      closing: "Hari Om Bol provides trusted, personalized guidance.",
    },
    why: {
      label: "Why Hari Om Bol",
      heading: "Guidance that feels calm, human, and always within reach.",
      cta: "Bring a little calm to your everyday.",
      features: [
        {
          title: "Unlimited Subscription",
          desc: "One affordable plan. Talk as long as your heart needs — never watch the clock again.",
        },
        {
          title: "Verified Astrologers",
          desc: "Every astrologer is hand-verified for authenticity, so guidance you receive is genuine.",
        },
        {
          title: "Saathi",
          desc: "A compassionate companion who simply listens — no judgment, no advice, just presence.",
        },
        {
          title: "Voice Calls",
          desc: "Hear a calming voice on the other end. Crystal-clear calls whenever life feels heavy.",
        },
        {
          title: "Chat",
          desc: "Prefer to type? Reach out over calm, thoughtful chat at your own gentle pace.",
        },
        {
          title: "Private Conversations",
          desc: "Your identity stays yours. Every conversation is confidential and fully secure.",
        },
      ],
    },
    pricing: {
      label: "Pricing",
      heading: "Choose Your Coin Pack",
      subtitle: "Flexible packs. Long validity. Just 2 coins per minute for calls and chats.",
      downloadApp: "Download App",
      whySubscribe: "Why Subscribe?",
      benefits: [
        "Coins Included",
        "Long Validity",
        "Flat 2 Coins/min",
        "Affordable Packs",
        "No Hidden Charges",
      ],
      currencyLabel: "Region",
      currencies: { inr: "India (INR)", usd: "International (USD)" },
      packHeaders: {
        trial: "TRIAL PACK",
        starter: "STARTER PACK",
        popular: "POPULAR PACK",
        super: "SUPER SAVER PACK",
      },
      tags: {
        oneTimeTrial: "ONE-TIME TRIAL",
        mostPopular: "MOST POPULAR",
        bestValue: "BEST VALUE",
      },
      coinsSuffix: "Coins",
      talktimeSuffix: "min talktime",
      validitySuffix: "days validity",
      noBonus: "No bonus",
      getCoins: (n) => `Get ${n} Coins`,
      usage: {
        title: "How your coins are used",
        saathi: "Saathi",
        astro: "Astro",
        chat: "Chat",
        call: "Call",
        rate: "2 /min",
        footnote:
          "The applicable rate displayed on the Platform at the time of use will govern the transaction.",
      },
    },
    faq: {
      label: "FAQ",
      heading: "Questions, answered.",
      cta: "Still curious? Experience it yourself.",
      items: [
        {
          q: "What is Hari Om Bol?",
          a: "Hari Om Bol is a spiritual guidance platform that connects you with experienced, verified Astrologers and dedicated Saathi through voice calls and chats—so trusted guidance is always within reach.",
        },
        {
          q: "How is this different from other astrology apps?",
          a: "Unlike traditional astrology apps, Hari Om Bol never charges per minute. One affordable subscription lets you focus on finding real answers instead of watching the clock.",
        },
        {
          q: "How do subscriptions work?",
          a: "Choose a coin pack—Trial, Starter, Popular, or Super Saver. Each pack comes with coins and a long validity window, and calls and chats are billed at a flat 2 coins per minute.",
        },
        {
          q: "How do coins work?",
          a: "Every pack comes with coins bundled in. Voice calls and chats are billed from your coin balance at a flat 2 coins per minute, giving you predictable, affordable guidance.",
        },
        {
          q: "Can I talk through chat?",
          a: "Yes. If you prefer typing over talking, you can reach both Saathi and Astrologers through calm, private chat at your own gentle pace.",
        },
        {
          q: "Can I cancel anytime?",
          a: "Absolutely. You are always in control—manage or cancel your subscription anytime directly from the app. No lock-ins, no pressure.",
        },
      ],
    },
    finalCta: {
      heading: "Start Your Spiritual Journey Today",
      subtitle:
        "Download Hari Om Bol and connect with trusted Astrologers and Saathi today.",
    },
    footer: {
      about: "About",
      privacy: "Privacy",
      terms: "Terms",
      support: "Support",
      playStore: "Play Store",
      appStore: "App Store",
      tagline: "Your spiritual companion, whenever life needs answers.",
      rights: "Hari Om Bol. Guidance, with grace.",
    },
    popup: {
      heading: "Start Your Spiritual Journey Today",
      text: "Connect instantly with verified Astrologers and compassionate Saathi.",
      maybeLater: "Maybe Later",
    },
    sticky: {
      name: "Hari Om Bol",
      tagline: "Trusted Spiritual Guidance",
      downloadApp: "Download App",
    },
  },

  hi: {
    brand: "हरि ॐ बोल",
    nav: {
      about: "परिचय",
      features: "विशेषताएँ",
      pricing: "मूल्य",
      faq: "सामान्य प्रश्न",
      download: "डाउनलोड",
      downloadApp: "ऐप डाउनलोड करें",
    },
    hero: {
      eyebrow: "एक सब्सक्रिप्शन · असीमित मार्गदर्शन",
      headingLine1: "आपका आध्यात्मिक साथी,",
      headingPre: "जब भी ज़िंदगी को चाहिए ",
      headingEmph: "उत्तर।",
      subtitle:
        "सत्यापित ज्योतिषियों और करुणामय साथी से वॉइस कॉल और चैट के ज़रिए जुड़ें—वो भी एक किफ़ायती सब्सक्रिप्शन में।",
      subtitleStrong: "कोई प्रति-मिनट शुल्क नहीं। बस भरोसेमंद मार्गदर्शन।",
      badges: [
        "कोई प्रति-मिनट शुल्क नहीं",
        "सत्यापित विशेषज्ञ",
        "निजी और सुरक्षित",
        "सब्सक्रिप्शन आधारित",
      ],
    },
    marquee: [
      "भरोसेमंद मार्गदर्शन",
      "करुणामय साथी",
      "निजी और सुरक्षित",
      "सत्यापित ज्योतिषी",
      "एक सब्सक्रिप्शन",
      "कोई प्रति-मिनट शुल्क नहीं",
    ],
    about: {
      label: "हरि ॐ बोल के बारे में",
      heading:
        "सच्चा मार्गदर्शन, उन लोगों से जो आपकी यात्रा को सच में समझते हैं।",
      p1: "क्या आप सच्चे आध्यात्मिक मार्गदर्शन, भरोसेमंद ज्योतिषियों, या किसी ऐसे व्यक्ति की तलाश में हैं जो आपके जीवन की यात्रा को सच में समझे? हरि ॐ बोल आपको अनुभवी ज्योतिषियों और समर्पित साथी से वॉइस कॉल और चैट के ज़रिए जोड़ता है।",
      p2pre: "पारंपरिक ज्योतिष ऐप्स के विपरीत, हरि ॐ बोल ",
      p2strong: "प्रति मिनट शुल्क नहीं लेता",
      p2rest: "—जिससे आप घड़ी देखने के बजाय उत्तर पाने पर ध्यान दे सकें।",
      topicsLabel: "चाहे आप मार्गदर्शन चाहें:",
      topics: [
        "करियर",
        "विवाह",
        "रिश्ते",
        "वित्त",
        "व्यापार",
        "स्वास्थ्य",
        "परिवार",
        "आध्यात्मिक विकास",
      ],
      closing: "हरि ॐ बोल भरोसेमंद, व्यक्तिगत मार्गदर्शन प्रदान करता है।",
    },
    why: {
      label: "क्यों हरि ॐ बोल",
      heading: "मार्गदर्शन जो शांत, मानवीय और हमेशा पहुँच में हो।",
      cta: "अपने रोज़मर्रा में थोड़ी शांति लाएँ।",
      features: [
        {
          title: "असीमित सब्सक्रिप्शन",
          desc: "एक किफ़ायती प्लान। जितनी देर दिल चाहे बात करें—अब घड़ी देखने की ज़रूरत नहीं।",
        },
        {
          title: "सत्यापित ज्योतिषी",
          desc: "हर ज्योतिषी की प्रामाणिकता स्वयं जाँची जाती है, ताकि आपको सच्चा मार्गदर्शन मिले।",
        },
        {
          title: "साथी",
          desc: "एक करुणामय साथी जो बस सुनता है—कोई निर्णय नहीं, कोई सलाह नहीं, बस साथ।",
        },
        {
          title: "वॉइस कॉल",
          desc: "दूसरी ओर एक शांत आवाज़ सुनें। जब भी जीवन भारी लगे, बिल्कुल स्पष्ट कॉल।",
        },
        {
          title: "चैट",
          desc: "टाइप करना पसंद है? अपनी सहज गति से शांत, विचारशील चैट करें।",
        },
        {
          title: "निजी बातचीत",
          desc: "आपकी पहचान आपकी रहती है। हर बातचीत गोपनीय और पूरी तरह सुरक्षित।",
        },
      ],
    },
    pricing: {
      label: "मूल्य",
      heading: "अपना कॉइन पैक चुनें",
      subtitle:
        "लचीले पैक। लंबी वैधता। कॉल और चैट के लिए सिर्फ़ 2 कॉइन प्रति मिनट।",
      downloadApp: "ऐप डाउनलोड करें",
      whySubscribe: "क्यों चुनें?",
      benefits: [
        "कॉइन शामिल",
        "लंबी वैधता",
        "सिर्फ़ 2 कॉइन/मिनट",
        "किफ़ायती पैक",
        "कोई छुपे शुल्क नहीं",
      ],
      currencyLabel: "क्षेत्र",
      currencies: { inr: "भारत (INR)", usd: "अंतरराष्ट्रीय (USD)" },
      packHeaders: {
        trial: "ट्रायल पैक",
        starter: "स्टार्टर पैक",
        popular: "पॉपुलर पैक",
        super: "सुपर सेवर पैक",
      },
      tags: {
        oneTimeTrial: "एक-बार ट्रायल",
        mostPopular: "सबसे लोकप्रिय",
        bestValue: "सर्वोत्तम मूल्य",
      },
      coinsSuffix: "कॉइन",
      talktimeSuffix: "मिनट टॉकटाइम",
      validitySuffix: "दिन वैधता",
      noBonus: "कोई बोनस नहीं",
      getCoins: (n) => `${n} कॉइन पाएँ`,
      usage: {
        title: "आपके कॉइन कैसे उपयोग होते हैं",
        saathi: "साथी",
        astro: "ज्योतिषी",
        chat: "चैट",
        call: "कॉल",
        rate: "2 /मिनट",
        footnote:
          "उपयोग के समय प्लेटफ़ॉर्म पर दिखाई गई लागू दर लेन-देन पर लागू होगी।",
      },
    },
    faq: {
      label: "सामान्य प्रश्न",
      heading: "आपके सवाल, जवाब सहित।",
      cta: "अभी भी उत्सुक? खुद अनुभव करें।",
      items: [
        {
          q: "हरि ॐ बोल क्या है?",
          a: "हरि ॐ बोल एक आध्यात्मिक मार्गदर्शन मंच है जो आपको अनुभवी, सत्यापित ज्योतिषियों और समर्पित साथी से वॉइस कॉल और चैट के ज़रिए जोड़ता है—ताकि भरोसेमंद मार्गदर्शन हमेशा पहुँच में रहे।",
        },
        {
          q: "यह अन्य ज्योतिष ऐप्स से कैसे अलग है?",
          a: "पारंपरिक ज्योतिष ऐप्स के विपरीत, हरि ॐ बोल कभी प्रति मिनट शुल्क नहीं लेता। एक किफ़ायती सब्सक्रिप्शन से आप घड़ी देखने के बजाय सच्चे उत्तर पाने पर ध्यान दे सकते हैं।",
        },
        {
          q: "सब्सक्रिप्शन कैसे काम करते हैं?",
          a: "एक कॉइन पैक चुनें—ट्रायल, स्टार्टर, पॉपुलर या सुपर सेवर। हर पैक में कॉइन और लंबी वैधता शामिल है, और कॉल व चैट सिर्फ़ 2 कॉइन प्रति मिनट पर काटे जाते हैं।",
        },
        {
          q: "कॉइन कैसे काम करते हैं?",
          a: "हर पैक के साथ कॉइन शामिल होते हैं। वॉइस कॉल और चैट आपके कॉइन बैलेंस से सिर्फ़ 2 कॉइन प्रति मिनट पर काटे जाते हैं, जिससे किफ़ायती मार्गदर्शन मिलता है।",
        },
        {
          q: "क्या मैं चैट के ज़रिए बात कर सकता हूँ?",
          a: "हाँ। अगर आपको बात करने से ज़्यादा टाइप करना पसंद है, तो आप साथी और ज्योतिषियों तक शांत, निजी चैट के ज़रिए पहुँच सकते हैं।",
        },
        {
          q: "क्या मैं कभी भी रद्द कर सकता हूँ?",
          a: "बिलकुल। नियंत्रण हमेशा आपके पास है—ऐप से सीधे कभी भी अपना सब्सक्रिप्शन प्रबंधित या रद्द करें। कोई बंधन नहीं, कोई दबाव नहीं।",
        },
      ],
    },
    finalCta: {
      heading: "आज ही अपनी आध्यात्मिक यात्रा शुरू करें",
      subtitle:
        "हरि ॐ बोल डाउनलोड करें और आज ही भरोसेमंद ज्योतिषियों और साथी से जुड़ें।",
    },
    footer: {
      about: "परिचय",
      privacy: "गोपनीयता",
      terms: "शर्तें",
      support: "सहायता",
      playStore: "प्ले स्टोर",
      appStore: "ऐप स्टोर",
      tagline: "आपका आध्यात्मिक साथी, जब भी ज़िंदगी को चाहिए उत्तर।",
      rights: "हरि ॐ बोल। कृपा के साथ मार्गदर्शन।",
    },
    popup: {
      heading: "आज ही अपनी आध्यात्मिक यात्रा शुरू करें",
      text: "सत्यापित ज्योतिषियों और करुणामय साथी से तुरंत जुड़ें।",
      maybeLater: "बाद में",
    },
    sticky: {
      name: "हरि ॐ बोल",
      tagline: "भरोसेमंद आध्यात्मिक मार्गदर्शन",
      downloadApp: "डाउनलोड",
    },
  },
};
